<template>
  <profile-card header-color="blue" class="search-sidebar">
    <template slot="header">
      <div class="card-icon">
        <md-icon>settings</md-icon>
      </div>
    </template>
    <template slot="content">
      <div class="info-wrap">
        <md-field v-if="tab == 'industry' || tab == 'market_area'">
          <label>Keyword Search</label>
          <md-input
            @keyup.enter="searchIndustriesByInput"
            v-model="search"
            aria-label="keyword search"
            placeholder="Search..."
            type="text"
          >
          </md-input>
          <div @click="searchIndustriesByInput">
            <md-icon>search</md-icon>
          </div>
        </md-field>

        <ul v-if="loaded" class="favorite-list">
          <li
            v-for="(favorite, index) in favorites"
            :key="index"
            class="favorite-list-item"
          >
            <div class="list-item-head">
              <span class="icon mr-5">
                <md-icon
                  @click.native="
                    chooseFavorite(favorite.data, favorite.search1)
                  "
                  class="add-item"
                  >playlist_add</md-icon
                >
                {{
                  tab === "industry"
                    ? favorite.search1
                    : getName(favorite.search1)
                }}
              </span>
              <!--<span class="title">{{
                tab === 'industry' ? favorite.data : ''
              }}</span>-->
              <span class="actions ml-5">
                <md-icon
                  @click.native="removeFavorite(favorite.id, index)"
                  class="delete-item"
                  >delete</md-icon
                >
              </span>
            </div>
            <!--<div class="list-item-body">
              {{
                tab === 'industry'
                  ? favorite.search1
                  : getName(favorite.search1)
              }}
            </div>-->
          </li>
        </ul>
      </div>
    </template>
  </profile-card>
</template>

<script>
import { ProfileCard } from "@/components";
import axios from "axios";
import { debounce } from "lodash";

export default {
  name: "sidebar-search",
  props: {
    title: {
      type: String,
    },
    tab: {
      type: String,
    },
  },
  components: { ProfileCard },
  data() {
    return {
      search: "",
      favorites: undefined,
      loaded: false,
      debounceHandlerIndustry: debounce(
        () => this.$store.commit("V_SET_SEARCH_INPUT_INDUSTRY", this.search),
        3000
      ),
      debounceHandlerMarketArea: debounce(
        () => this.$store.commit("V_SET_SEARCH_INPUT_MARKET_AREA", this.search),
        3000
      ),
    };
  },
  methods: {
    getName: function(name) {
      return name.split("[")[0];
    },
    getData: function(name) {
      if (name) {
        return name.split("[")[1].split("]")[0];
      }
    },
    chooseInput: function() {
      if (this.tab === "industry") {
        if (this.search) {
          this.sendIndustryLoad(true);
          this.$store.commit("V_SET_SEARCH_INDUSTRIES", null);
          this.$store.commit("V_SET_SEARCH_LOADING_INDUSTRY", true);
          this.debounceInputIndustry();
        } else {
          this.$store.commit("V_SET_SEARCH_LOADING_INDUSTRY", false);
          this.$store.commit("V_SET_SEARCH_INPUT_INDUSTRY", "");
        }
      } else if (this.tab === "market_area") {
        if (this.search) {
          this.$store.commit("V_SET_SEARCH_MARKET_AREAS", null);
          this.$store.commit("V_SET_SEARCH_LOADING_MARKET_AREA", true);
          this.debounceInputMarketArea();
        } else {
          this.$store.commit("V_SET_SEARCH_LOADING_MARKET_AREA", false);
          this.$store.commit("V_SET_SEARCH_INPUT_MARKET_AREA", "");
        }
      }
    },
    debounceInputIndustry: function() {
      this.debounceHandlerIndustry();
    },
    debounceInputMarketArea: function() {
      this.debounceHandlerMarketArea();
    },
    removeFavorite: async function(id, index) {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      this.favorites.splice(index, 1);

      await axios.post(
        process.env.VUE_APP_API_BASE_URL + "/user/favorites/delete",
        {},
        {
          params: {
            session_id: currentSession,
            favoriteID: id,
          },
        }
      );
    },
    chooseFavorite: async function(data, title) {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      if (this.tab === "industry") {
        this.$store.commit("V_SET_INDUSTRY", title);

        // await axios
        //   .post(
        //     process.env.VUE_APP_API_BASE_URL + '/user/search_profiles/imr',
        //     {},
        //     {
        //       params: {
        //         session_id: currentSession,
        //         industry: data,
        //         profile_id: this.profileId ? this.profileId : '0',
        //         type: 'imr',
        //       },
        //     }
        //   )
        //   .then((res) => {
        //     if (res.hasOwnProperty('data') && res.data.error) {
        //       this.$store.commit('SET_ERROR_BIT', true);
        //       this.$store.commit(
        //         'SET_ERROR_INFO',
        //         '<br>' +
        //           'Server responded with error = True <br> errorCode: ' +
        //           res.data.errorCode +
        //           `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/search_profiles/imr" <br>`
        //       );
        //       throw new Error(
        //         '<br>' +
        //           'Server responded with error = True <br> errorCode: ' +
        //           res.data.errorCode
        //       );
        //     }
        //     const { id } = res.data;
        //     this.$store.commit('M_SET_PROFILE_ID', id);
        //   });
      } else if (this.tab === "market_area") {
        if (data === "zips") {
          if (data === "zips") {
            this.$store.commit("V_SET_MARKET_AREA", title);
            // });
          }
        } else if (data === "map_center") {
          // `${this.radius} miles away from ${this.streetAddress}, ${this.zipCode} [map_center]`
          let map_center = title.split(" ")[4].slice(0, -1);
          let map_center_zip = title.split(" ")[5];
          let radius = title.split(" ")[0];

          this.$store.commit("V_SET_MARKET_AREA", title);
          // });
        } else {
          this.$store.commit("V_SET_MARKET_AREA", title);
          // });
        }
      }
    },
    getFavorites: async function() {
      let currentSession = localStorage.getItem(
        "vue-authenticate.vueauth_access_token"
      );

      if (this.tab === "industry") {
        this.$store.dispatch("favorite/getIndustry").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.loaded = true;
        });
        this.$store.commit("V_SET_FAVORITE_INDUSTRIES", this.favorites);
      } else if (this.tab === "market_area") {
        this.$store.dispatch("favorite/getMarketArea").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.loaded = true;
        });
        this.$store.commit("V_SET_FAVORITE_MARKET_AREAS", this.favorites);
      } else if (this.tab === "sales_class") {
        this.$store.dispatch("favorite/getSalesClass").then((res) => {
          if (res.hasOwnProperty("data") && res.data.error) {
            this.$store.commit("SET_ERROR_BIT", true);
            this.$store.commit(
              "SET_ERROR_INFO",
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode +
                `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/favorites/get" <br>`
            );
            throw new Error(
              "<br>" +
                "Server responded with error = True <br> errorCode: " +
                res.data.errorCode
            );
          }
          this.favorites = res.data.data;
          this.loaded = true;
        });
        this.$store.commit("V_SET_FAVORITE_SALES_CLASS", this.favorites);
      }
    },
    sendIndustryLoad: function(isLoading) {
      this.$emit("load-industry", { isLoading: isLoading });
    },
    searchIndustriesByInput: async function() {
      let apiData = [];

      if (this.tab === "industry") {
        this.sendIndustryLoad(true);
        this.$store.commit("V_SET_SEARCH_INDUSTRIES", null);
        this.$store.commit("V_SET_SEARCH_LOADING_INDUSTRY", true);
        let industries = [];
        let availableIndustries = [];
        if (this.search != null && !!this.search) {
          //availableIndustries
          await axios
            .get(process.env.VUE_APP_API_BASE_URL + "/info/industries", {
              params: {
                type: "valuation",
                search: this.search,
                industry: this.getData(this.industry) || "0",
                area: parseInt(this.getData(this.marketArea)) || 0,
              },
            })
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode
                );
              }
              apiData = res.data.data;
              apiData.forEach((industry) => {
                availableIndustries.push(
                  `${industry.name} [${industry.bznaics}]`
                );
                industries.push(`${industry.name} [${industry.bznaics}]`);
              });
              this.sendIndustryLoad(false);
            });

          /*await axios
            .get(process.env.VUE_APP_API_BASE_URL + '/info/industries', {
              params: {
                type: 'valuation',
                search: this.search,
                industry: '0',
                area: 0,
              },
            })
            .then((res) => {
              if (res.hasOwnProperty('data') && res.data.error) {
                this.$store.commit('SET_ERROR_BIT', true);
                this.$store.commit(
                  'SET_ERROR_INFO',
                  '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode +
                  `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/industries" <br>`
                );
                throw new Error(
                  '<br>' +
                  'Server responded with error = True <br> errorCode: ' +
                  res.data.errorCode
                );
              }
              apiData = res.data.data;
              apiData.forEach((industry) => {
                industries.push(`${industry.name} [${industry.bznaics}]`);
              });
            });
          */
          let temp = [industries, availableIndustries];
          this.$store.commit("V_SET_SEARCH_INDUSTRIES", temp);
        } else {
          this.$store.commit("V_SET_SEARCH_INDUSTRIES", null);
        }
      }
    },
    searchMarketAreasByInput: async function() {
      if (this.tab === "market_area") {
        let marketAreas = [];
        let availableMarketAreas = [];
        if (
          this.searchInputMarketArea != null &&
          !!this.searchInputMarketArea
        ) {
          //availableMarketAreas
          await axios
            .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
              params: {
                type: "valuation",
                search: this.searchInputMarketArea,
                industry: this.getData(this.industry) || "0",
              },
            })
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode
                );
              }
              availableMarketAreas = res.data.data;
            });

          await axios
            .get(process.env.VUE_APP_API_BASE_URL + "/info/areas", {
              params: {
                type: "valuation",
                search: this.searchInputMarketArea,
                industry: "0",
              },
            })
            .then((res) => {
              if (res.hasOwnProperty("data") && res.data.error) {
                this.$store.commit("SET_ERROR_BIT", true);
                this.$store.commit(
                  "SET_ERROR_INFO",
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/info/areas" <br>`
                );
                throw new Error(
                  "<br>" +
                    "Server responded with error = True <br> errorCode: " +
                    res.data.errorCode
                );
              }
              marketAreas = res.data.data;
            });

          let temp = [marketAreas, availableMarketAreas];
          this.$store.commit("V_SET_SEARCH_MARKET_AREAS", temp);
        } else {
          this.$store.commit("V_SET_SEARCH_MARKET_AREAS", null);
        }
      }
    },
  },
  async created() {
    this.$store.commit("V_SET_SEARCH_INDUSTRIES", null);
    this.$store.commit("V_SET_SEARCH_MARKET_AREAS", null);
    this.$store.commit("V_SET_SEARCH_INPUT_INDUSTRY", null);
    this.$store.commit("V_SET_SEARCH_INPUT_MARKET_AREA", null);
    await this.getFavorites();
  },
  computed: {
    profileId() {
      return this.$store.getters.vProfileId;
    },
    searchInputIndustry() {
      return this.$store.getters.vSearchInputIndustry;
    },
    searchInputMarketArea() {
      return this.$store.getters.vSearchInputMarketArea;
    },
    favoriteIndustries() {
      return this.$store.getters.vFavoriteIndustries;
    },
    favoriteMarketAreas() {
      return this.$store.getters.vFavoriteMarketAreas;
    },
    favoriteSalesClass() {
      return this.$store.getters.vFavoriteSalesClass;
    },
    salesClass() {
      return this.$store.getters.vSalesClass;
    },
    industry() {
      return this.$store.getters.vIndustry;
    },
    marketArea() {
      return this.$store.getters.vMarketArea;
    },
  },
  watch: {
    favoriteIndustries(newValue, oldValue) {
      if (this.tab === "industry") {
        this.favorites = this.$store.getters.vFavoriteIndustries;
      }
    },
    favoriteMarketAreas(newValue, oldValue) {
      if (this.tab === "market_area") {
        this.favorites = this.$store.getters.vFavoriteMarketAreas;
      }
    },
    favoriteSalesClass(newValue, oldValue) {
      if (this.tab === "sales_class") {
        this.favorites = this.$store.getters.vFavoriteSalesClass;
      }
    },
    searchInputIndustry(newValue, oldValue) {
      //this.searchIndustriesByInput();
    },
    searchInputMarketArea(newValue, oldValue) {
      this.searchMarketAreasByInput();
    },
  },
};
</script>
<style lang="scss"></style>
